module.exports = __webpack_public_path__ + "img/item3.7c588de8.jpg";